import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useSymbolFromCurrency } from '../../utils/CurrencyUtil';
import numeral from 'numeral';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const Div = styled.div`
  display: inline-block;
  width: 100%;
  padding: ${(props) => (props.iconSuffix ? '0rem 2rem 0rem 0rem' : '0rem 0rem 0rem 0rem')};
  font-size: ${(props) => (props.size === 'large' ? '20px' : '16px')};
  font-weight: ${(props) => (props.primary ? '600' : '500')};
  color: ${(props) => {
    if (props.color) {
      return props.color;
    }
    return props.clickable ? p4Tokens.fieldLink : p4Tokens.colorNeutralForeground1;
  }};
  background-image: none;
  vertical-align: baseline;
  line-height: inherit;
  text-align: ${(props) => (props.align ? props.align : 'right')};
  cursor: ${(props) => {
    if (props.disabled) {
      return 'not-allowed ';
    }
    return props.clickable ? 'pointer' : null;
  }};
`;

const CardNumber = ({
  decimals,
  iconSuffix,
  primary,
  type,
  size,
  color,
  align,
  testId,
  value: propValue,
  onClick: clickable,
  valueMask,
}) => {
  let value = propValue;
  if (type === 'text') {
    if (!value) value = '';
  } else {
    if (value === '' || !value) value = 0;
    if (decimals !== null && decimals !== undefined && typeof propValue === 'number') {
      value = numeral(value).format(`0,0.${'0'.repeat(decimals ?? 0)}`);
    } else {
      value = numeral(value).format(valueMask);
    }
  }

  const prefix = useSymbolFromCurrency(type, value);

  return (
    <Div
      data-testid={testId}
      primary={primary}
      size={size}
      color={color}
      align={align}
      iconSuffix={iconSuffix}
      clickable={clickable}
    >
      {prefix}
      {prefix?.length > 1 ? ' ' : ''}
      {value}
    </Div>
  );
};

CardNumber.propTypes = {
  type: PropTypes.string.isRequired,
  iconSuffix: PropTypes.bool,
};
CardNumber.defaultProps = {
  type: 'numeric',
  iconSuffix: false,
  valueMask: '0,00.00',
};

export default CardNumber;
